/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
*/

// IP-NOTICE: PROTECTED
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarComponent } from '../components/snack-bar/snack-bar.component';

@Injectable({providedIn: 'root'})
export class SnackBarService {
  constructor(protected snackBar: MatSnackBar) {}

  success(message: string, title?: string) {
    this.snackBar.openFromComponent(SnackBarComponent, {
      duration: 12000,
      panelClass: 'success-snackbar',
      data: { message: message, title: title, icon: 'done' }
    });
  }

  warning(message: string, title?: string) {
    this.snackBar.openFromComponent(SnackBarComponent, {
      duration: 12000,
      panelClass: 'warning-snackbar',
      data: { message: message, title: title, icon: 'warning' }
    });
  }

  error(message: string, title?: string) {
    this.snackBar.openFromComponent(SnackBarComponent, {
      duration: 12000,
      panelClass: 'error-snackbar',
      data: { message: message, title: title, icon: 'error' }
    });
  }

  info(message: string, title?: string) {
    this.snackBar.openFromComponent(SnackBarComponent, {
      duration: 12000,
      panelClass: 'info-snackbar',
      data: { message: message, title: title, icon: 'info' }
    });
  }

  dismiss() {
    this.snackBar.dismiss();
  }
}
